<template>
  <a-radio-group v-if="tagType=='radio'" @change="handleInput" :value="getValueSting" :placeholder="placeholder" :disabled="disabled">
    <a-radio v-for="(item, key) in dictOptions" :key="key" :value="item.value">{{ item.text }}</a-radio>
  </a-radio-group>

  <a-select  v-else-if="tagType=='select'" :getPopupContainer = "(target) => target.parentNode"  :disabled="disabled" :value="getValueSting" :placeholder="placeholder" @change="handleInput">
    <a-select-option v-for="(item, key) in dictOptions" :key="key" :value="item.value">
      <span style="display: inline-block;width: 100%" :title=" item.text || item.label ">
        {{ item.text || item.label }}
      </span>
    </a-select-option>
  </a-select>
</template>

<script>
  import {ajaxGetDictItems} from '@/api/api'

  export default {
    name: "JDictSelectTag",
    props: {
      dictCode: String,
      placeholder: String,
      triggerChange: Boolean,
      disabled: Boolean,
      value: [String, Number],
      type: String
    },
    data() {
      return {
        dictOptions: [],
        tagType:""
      }
    },
    watch:{
      dictCode:{
        immediate:true,
        handler() {
          this.initDictData()
        },
      }
    },
    created() {
      // console.log(this.dictCode);
      if(!this.type || this.type==="list"){
        this.tagType = "select"
      }else{
        this.tagType = this.type
      }
      //获取字典数据
    //    this.initDictData();
    },
    computed: {
      getValueSting(){
        return this.value ? this.value.toString() : null;
      },
    },
    methods: {
      initDictData() {
        //根据字典Code, 初始化字典数组
        ajaxGetDictItems(this.dictCode, null).then((res) => {
          if (res.success) {
            if(res.result.length>0){

              this.dictOptions = res.result;
            }
//                console.log(res.result);
          }
        })
      },
      handleInput(e) {
        let val;
        if(this.tagType=="radio"){
          val = e.target.value
        }else{
          val = e
        }
        console.log(e);
        if(this.triggerChange){
          this.$emit('change', val);
          this.$emit('add', val);
        }else{
          this.$emit('input', val);
        }
      },
      setCurrentDictOptions(dictOptions){
        this.dictOptions = dictOptions
      },
      getCurrentDictOptions(){
        return this.dictOptions
      },
      getSelectLabels(){
        if(this.dictOptions){
          let dataStr=""
          this.dictOptions.forEach(element => {
            if(element.value==this.value){
              if(element.text){
                dataStr=element.text
              }else if(element.label){
                dataStr=element.label
              } 
            }
          });
          return dataStr
        }
      },
      clearData(){
        if(!this.triggerChange){
         this.$emit('input', ""); 
        }
      }
    }
  }
</script>

<style scoped>
</style>